<template>
  <div id="zoom">
    <div class="row mt-md-5">
      <div class="col-md-12 title">
        <h1>絵本を体験する読み聞かせ会</h1>
        <h1>Zoomについて</h1>
      </div>
      <div class="col-md-12 description">
        <p>
          今回の読み聞かせは、web会議アプリ「Zoom」にてご参加いただけます。PC、スマートフォン、タブレットからでも参加可能です。ダウンロード方法は下記をお読みください。本イベントでは、主催者側の画面のみが映されますので、参加者同士で映像が映されたり、情報が共有されることはございません。
        </p>
      </div>

      <div class="col-md-12 how-to-download">
        <h2>
          Zoomダウンロード方法
        </h2>

        <p>
          今回の読み聞かせ会は、Zoomアプリをダウンロードすれば、アカウントを作成いただかなくてもご利用いただけます。
        </p>

        <h3>
          【PC、タブレットへのインストール方法】
        </h3>

        <p>
          Zoom公式サイト（https://zoom.us）のホーム画面下部「ダウンロード」から、「ミーティングクライアント」をクリックします。「ミーティング用Zoomクライアント」のダウンロードをクリックすると、アプリがダウンロードされます。
        </p>

        <div class="col-md-12 image">
          <img src="/static/images/zoom/zoom_sosa.png" class="img-fluid" alt="zoom操作方法画像">
        </div>

        <h3>
          【スマートフォンへのインストール方法】
        </h3>

        <p>
          iPhoneの場合はApp Storeより、Androidスマホの場合はGoogle Playより「ZOOM Cloud Meetings」を検索し、ダウンロードします。
        </p>

        <h2>事前の動作確認</h2>
        <p>
          読み聞かせ開始1時間前までに、参加者の皆さまへZoomへの参加URLをお送りいたします。はじめてZoomをご使用いただく方や、ご不安な方には、お早めにログインいただき、音声や画面に不具合がないか、ご確認いただくことができます。
        </p>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    title: 'Zoomについて',
    name: 'zoom',
    mounted: function() {
      this.$nextTick(function () {
        try {
          FONTPLUS.reload();
        } catch (error) {
          console.log(error.message);
        }
      })
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Zoom.vue